import { render, staticRenderFns } from "./VPrescriptionDrawingUploadDropzone.vue?vue&type=template&id=2db60220&"
import script from "./VPrescriptionDrawingUploadDropzone.vue?vue&type=script&lang=ts&"
export * from "./VPrescriptionDrawingUploadDropzone.vue?vue&type=script&lang=ts&"
import style0 from "./VPrescriptionDrawingUploadDropzone.vue?vue&type=style&index=0&id=2db60220&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports